import script from "./DInputControl.vue?vue&type=script&setup=true&lang=js"
export * from "./DInputControl.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__